import { FeatureFlagTabs } from '@shared/guards/basic-redirect-to-next-tab.guard';

import { Flags } from '../services/launch-darkly.service';
import { BUDGETS_ROUTES_FEATURE_FLAGS } from './feature-flags-guards/budgets-feature-flags.const';
import { FORECAST_ROUTES_FEATURE_FLAGS } from './feature-flags-guards/forecast-routes-feature-flags.const';
import { INVESTIGATOR_ROUTES_FEATURE_FLAGS } from './feature-flags-guards/investigator-feature-flags.const';
import { PERIOD_CLOSE_ROUTES_FEATURE_FLAGS } from './feature-flags-guards/period-close-routes-feature-flags.const';
import { SETTINGS_ROUTES_FEATURE_FLAGS } from './feature-flags-guards/settings-routes-feature-flags.const';

interface RetriggerNode {
  flag: keyof Flags;
  value: string;
}

const mapFromGuardsFFTabs = (ffTabs: FeatureFlagTabs) =>
  Object.entries(ffTabs)
    .map(([path, featureFlag]: [string, keyof Flags | null]) => ({
      flag: featureFlag,
      value: path,
    }))
    .filter(
      (retrigerNode: { flag: keyof Flags | null; value: string }) => !!retrigerNode.flag
    ) as RetriggerNode[];

export const PagesToRetriggerCanActivate: RetriggerNode[] = [
  ...mapFromGuardsFFTabs(PERIOD_CLOSE_ROUTES_FEATURE_FLAGS),
  ...mapFromGuardsFFTabs(BUDGETS_ROUTES_FEATURE_FLAGS),
  ...mapFromGuardsFFTabs(FORECAST_ROUTES_FEATURE_FLAGS),
  ...mapFromGuardsFFTabs(INVESTIGATOR_ROUTES_FEATURE_FLAGS),
  ...mapFromGuardsFFTabs(SETTINGS_ROUTES_FEATURE_FLAGS),
];
